import { useAppSelector } from '../../../../store/hooks';
import { getAreFirmwaresFiltersVisible } from '../../store/selectors/get-are-firmwares-filters-visible/get-are-firmwares-filters-visible.selector';

export const useAreFirmwaresFiltersVisible = (): boolean => {
  return useAppSelector(getAreFirmwaresFiltersVisible);
};
